import {
  FAMILLE_SEARCH_SUCCES,
  FAMILLE_SEARCH_ECHEC,
  FAMILLE_SEARCH_RESET,
  FAMILLE_SEARCH_REQUETTE,
  FAMILLE_LISTE_REQUETTE,
  FAMILLE_LISTE_SUCCES,
  FAMILLE_LISTE_ECHEC,
  FAMILLE_SEARCH_REQUETTE_LOC,
  FAMILLE_SEARCH_SUCCES_LOC,
  FAMILLE_SEARCH_ECHEC_LOC,
} from "../constantes/famillesConstantes";
import axios from "axios";

//const uri = `http://${manifest.debuggerHost.split(":").shift()}:5000`;
//const uri = `https://ecreal.herokuapp.com`;
//const uri = `https://ecreal.onrender.com`;
//const uri = `https://ahmed.prod-manager.tk/back`;
//const uri = `https://gestpro.globalsystempro.com/back`;
import { store } from "../store";
let uri = "";
function changeURi() {
  const cliServ = store.getState().cliServState.cliServ;
  return (uri =
    cliServ != 0
      ? cliServ == "SERV1"
        ? process.env.REACT_APP_SERV_1
        : process.env.REACT_APP_SERV_2
      : process.env.REACT_APP_SERV_1);
}
changeURi();
export const famillesSearch = (search) => async (dispatch, getState) => {
  dispatch({ type: FAMILLE_SEARCH_RESET });
  const {
    client: { client },
  } = getState();
  console.log(client);

  try {
    dispatch({ type: FAMILLE_SEARCH_REQUETTE });
    //sette requet api va exploité le resultat de requet mongo a partir de controller famillecontroller
    //voir getFamilleByNom dans le fichier familleController.js
    const { data } = await axios.get(`${uri}/api/famille/${search}`);
    let fautFiltre = client.activites != "T" && client.activites;
    if (fautFiltre) {
      console.log(
        "ce utilisateur a activité de " +
          client.activites +
          " donc il faut faire le filtrage selon ce critére!"
      );
      let datafilter = data.filter((family) =>
        family.activites.some(
          (activity) => activity.code_act === client.activites
        )
      );
      dispatch({ type: FAMILLE_SEARCH_SUCCES, payload: datafilter });
    } else {
      console.log("Pas de filtrage nécessaire");
      dispatch({ type: FAMILLE_SEARCH_SUCCES, payload: data });
    }
    /*  console.log(data.find(d=>d.code_fam=='18').activites)
    let datafilter=data.filter(d=>d.activites[0].lib_act==client.activites)
     console.log("filter"+datafilter)
    console.log("client activité:"+client.activites.length)
    if(client.activites != "TOUT" || client.activites != undefined){
      console.log("filtrage famille par activites")
      if(data.find(f=>f.activites[0].lib_act==client.activites)){
        console.log('ce utilisateur a activité de '+client.activites+' donc il faut faire le filtrage selon ce critére!')
         datafilter=data.filter(d=>d.activites[0].lib_act==client.activites)
        dispatch({ type: FAMILLE_SEARCH_SUCCES, payload: datafilter});
      }
    }else{
      dispatch({ type: FAMILLE_SEARCH_SUCCES, payload: data });

    }*/
  } catch (error) {
    dispatch({ type: FAMILLE_SEARCH_ECHEC, payload: error });
  }
};
export const famillesSearchLoc = (search, chaine) => async (dispatch) => {
  dispatch({ type: FAMILLE_SEARCH_RESET });
  try {
    dispatch({ type: FAMILLE_SEARCH_REQUETTE_LOC });
    //sette requet api va exploité le resultat de requet mongo a partir de controller famillecontroller
    //voir getFamilleByNom dans le fichier familleController.js

    const { data } = await axios.get(
      `http://${chaine.host}:5000/api/oracle/famille/${chaine.host}/${chaine.database}/${chaine.user}/${chaine.pwd}/${search}`
    );

    dispatch({ type: FAMILLE_SEARCH_SUCCES_LOC, payload: data });
  } catch (error) {
    dispatch({ type: FAMILLE_SEARCH_ECHEC_LOC, payload: error });
  }
};
export const listeFamille = () => async (dispatch) => {
  try {
    dispatch({ type: FAMILLE_LISTE_REQUETTE });
    const { data } = await axios.get(`${uri}/api/famille`);
    dispatch({ type: FAMILLE_LISTE_SUCCES, payload: data });
  } catch (error) {
    dispatch({
      type: FAMILLE_LISTE_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};
